"use client"

import React, { useState, useEffect } from "react"
import { getCustomerBalances, type CustomerBalance } from "@/lib/data/balances"
import { Eye, EyeOff } from "lucide-react"
import { usePathname, useSearchParams } from "next/navigation"
import { useTranslation } from "react-i18next"

const BalanceDisplay = () => {
  const { t } = useTranslation()
  const [balances, setBalances] = useState<CustomerBalance[]>([])
  const [showBalance, setShowBalance] = useState(true)
  const [loading, setLoading] = useState(false)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const search = searchParams?.toString()

  useEffect(() => {
    const fetchBalances = async () => {
      try {
        setLoading(true)
        const response = await getCustomerBalances()
        setBalances(response.customer_balances)
      } catch (error) {
        // ignore
      } finally {
        setLoading(false)
      }
    }

    fetchBalances()
  }, [pathname, search])

  const totalBalance = balances.reduce((total, balance) => {
    return total + balance.in_app_balance + balance.withdrawable_balance
  }, 0)

  const formatBalance = (amount: number) => {
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
    }).format(amount)
  }

  return (
    <div className="flex flex-row gap-2 items-center">
      {/* Load balance button is temporarily disabled with the wallet page. */}

      <div className="flex items-center gap-1 rounded-full border border-orange-200 bg-white px-3 py-1.5 text-sm shadow-sm">
        <span className="font-semibold text-slate-700">
          {showBalance ? (loading ? "..." : formatBalance(totalBalance)) : t("navbar.hiddenBalance")}
        </span>
        <button
          onClick={() => setShowBalance(!showBalance)}
          className="transition text-slate-500 hover:text-orange-600"
          aria-label="toggle-balance-visibility"
        >
          {showBalance ? (
            <EyeOff className="w-4 h-4" />
          ) : (
            <Eye className="w-4 h-4" />
          )}
        </button>
      </div>
    </div>
  )
}

export default BalanceDisplay
